interface PageHeaderProps {
  className?: string;
  children?: React.ReactNode;
}

export const PageHeader = ({ className, children }: PageHeaderProps) => {
  return (
    <header
      className={`flex w-full items-center justify-between border-b bg-white px-6 py-4 shadow-sm ${className}`}
    >
      {children}
    </header>
  );
};
